import DataGridBaseCheckbox from './DataGridBaseCheckbox';

/** Pass to `<DataGrid slots={dataGridNativeCheckboxSlots} />` when using `checkboxSelection`. */
export const dataGridNativeCheckboxSlots = {
  baseCheckbox: DataGridBaseCheckbox,
};
